export enum GpWpStatus {
    DECLINE,
    IMPROVE,
    WIN,
    NEW,
    UNKNOWN,
}
